import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import IconWrapper from './IconWrapper';
import './Navbar.css';

const NavigationBar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Domů' },
    { path: '/christmas', label: 'Vánoce' },
    { path: '/services', label: 'Služby' },
    { path: '/gallery', label: 'Galerie' },
    { path: '/about', label: 'O mně' },
    { path: '/contact', label: 'Kontakt' }
  ];

  return (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <Navbar
        expand="lg"
        className={`custom-navbar ${isScrolled ? 'scrolled' : ''}`}
        fixed="top"
        expanded={isExpanded}
        onToggle={() => setIsExpanded(!isExpanded)}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="brand">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="d-flex align-items-center"
            >
              <img
                src="/images/fajnefotky_logo.png"
                alt="Fajne Fotky"
                className="brand-logo"
              />
            </motion.div>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="custom-toggler"
          >
            {isExpanded ? <IconWrapper icon={FaTimes} /> : <IconWrapper icon={FaBars} />}
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {navItems.map((item, index) => (
                <motion.div
                  key={item.path}
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Nav.Link
                    as={Link}
                    to={item.path}
                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={() => setIsExpanded(false)}
                  >
                    {item.label}
                  </Nav.Link>
                </motion.div>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
};

export default NavigationBar;
